export default __webpack_public_path__ + "static/media/what-we-do-rectangle2.8406e081.svg";